import React, { useEffect, useState, } from 'react';
// import useSWR from 'swr'
import Axios from 'axios';
import { TextView } from '../TextView/TextView';
import { Spinner } from '../Spinner/Spinner';
// import { Citation } from '../Citation/Citation';
import { getList } from './queries';


export interface MyComponentProps {
  // Define your prop types here
  start: string,
  source: string,
}


export const CitationTableList: React.FC<MyComponentProps> = (props) => {


  // const axiosFetcher = (url: string) => Axios.get(url).then((d) => {
  //   console.log("Test", d)
  //   const matches = d.data.results.bindings.map((b: any) => {
  //     return (
  //       {
  //         "startPara": b?.startPara.value,
  //         "source": b?.source.value,
  //         "startTranscription": b?.startTranscription?.value,
  //         "sourceTranscription": b?.sourceTranscription?.value,
  //         "elementText": b?.elementText?.value
  //       }
  //     )

  //   })
  //   return matches
  // });


  const [matches, setMatches] = useState([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showSource, setShowSource] = useState<string>("")
  const [showStart, setShowStart] = useState<string>("")
  // const {data, error, isLoading} = useSWR("https://sparql.scta.info/ds/query?query=" + getList(props.start, props.source) + "&format=json", axiosFetcher)
  
  useEffect(() => {
    getMatches()
  }, [props.start,props.source])  
  

  const getMatches = () => {
    const query = getList(props.start, props.source)
    setIsLoading(true)
    
    Axios.get("https://sparql.scta.info/ds/query", {params: {query: query}}).then((d) => {
    
      // for each is happening here instead of map because query will return 
      // separate entries for quotes that have more than one ref
      // and one there are multiple refs for a single quote, we want to group them
      // together
      const matchObject: any = {}
      d.data.results.bindings.forEach((b:any) => {
        const key = b?.startPara.value + "===" + b?.source.value
        if (matchObject.hasOwnProperty(key)){
          matchObject[key].ref.push(
            {
            elementRefText: b?.elementRefText?.value, 
            elementRef: b?.elementRef?.value
            }
          )
        }
        else{
          matchObject[key] = {
            "startPara": b?.startPara.value, 
            "source": b?.source.value,
            "startTranscription": b?.startTranscription?.value,
            "sourceTranscription": b?.sourceTranscription?.value,
            "elementText": b?.elementText?.value,
            "startLongTitle": b?.startLongTitle?.value,
            "sourceLongTitle": b?.sourceLongTitle?.value,
            "startAuthorTitle": b?.startAuthorTitle?.value,
            "sourceAuthorTitle": b?.sourceAuthorTitle?.value,
            "ref": [
              {
                "elementRefText": b?.elementRefText?.value,
                "elementRef": b?.elementRef?.value
              }
            ]
          }
        }
      })
    setMatches(Object.values(matchObject))
    setIsLoading(false)
  
    
  
  })
  }

  // Handle loading and error states
  //if (error) return <div>Error loading text</div>;
  //if (isLoading) return <div>Loading...</div>;
  return (
    <>
    {isLoading ? 
      <Spinner/> 
    :
    <div>
      {
        (typeof (matches) === "string") ? <p>{matches}</p> :
          matches.map((m, i) => {
            return (
              <div key={"no-" + i} style={{ display: "flex", justifyContent: "space-around", borderBottom: "1px dotted black" }}>
                <div style={{width: "45%"}}>
                  {/* <Citation tresourceid={m["startTranscription"]} /> */}
                  {/* <p>{m["startAuthorTitle"]}, {m["startLongTitle"]}</p> */}
                  {m.ref.map((r:any, i:number) => {
                    return (
                      <p key={"ref-" + i}>Historical Ref: {r["elementRefText"]}</p>
                    )
                  })
                  }
                  
                  {/* <p>{m["elementText"]}</p> */}
                  <div>Text: <TextView 
                  text={m["elementText"]} 
                  tresourceid={m["startTranscription"]} hideCitation={true}/> 
                  </div>
                  <p>{m["startAuthorTitle"]}, {m["startLongTitle"]}</p>
{/*                   
                  {showStart && showStart === m["startTranscription"] ? <TextView 
                  text={m["elementText"]} 
                  tresourceid={m["startTranscription"]} compareTresourceid={m["sourceTranscription"]}/> 
                  : <p onClick={() => {setShowStart(m["startTranscription"])}}>Show</p>
                  } */}
                  
                </div>
                <div style={{width: "45%"}}>
                  {/* <Citation tresourceid={m["sourceTranscription"]} /> */}
                  {/* <p>{m["sourceAuthorTitle"]}, {m["sourceLongTitle"]}</p> */}
                  {/* <p>source</p> */}
                  <p>{m["sourceAuthorTitle"]}, {m["sourceLongTitle"]}</p>
                  {/* <TextView 
                  compareText={m["elementText"]} 
                  compareTresourceid={m["startTranscription"]} tresourceid={m["sourceTranscription"]} hideCitation={true}/>  */}
                  
                  {showSource && showSource === m["sourceTranscription"] ? 
                  <>
                  <TextView 
                  compareText={m["elementText"]} 
                  compareTresourceid={m["startTranscription"]} tresourceid={m["sourceTranscription"]} hideCitation={true}/>
                  <p onClick={() => {setShowSource("")}}>Hide Source Text</p>
                  </> 
                  : <p onClick={() => {setShowSource(m["sourceTranscription"])}}>Show Source Text</p>
                  }
                </div>
              </div>
            )
          })
      }
    </div>
  }
  </>
  );
};
